import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { saveCatalogUnChecked } from '@web-schedule/service';
import { thunkHelperFactory } from '@web-common/utils/redux_utils';
export const SCHEDULED_POINT_FORMAT = 'YYYY-MM-DD';
const initState = {
    scheduleEventList: [],
    catalogList: [],
    scheduleSync: null,
    scheduleEvent: null,
    unSelectedCatalogIds: [],
    miniSelectedDay: moment(),
    scheduledDate: [],
    weekFirstDay: 0,
    weekNumbersVisible: true,
    creatDirectStartTime: moment(),
    creatDirectEndTime: moment(),
    activeStartDate: new Date(),
    activeEndDate: new Date(),
    scheduleEditFrom: '',
    scheduleNoticeLastUpdateTime: new Date(Date.now() - 60 * 60 * 1000),
    settingZoneList: [],
    showSecondaryZone: false,
    lastSelectTimezone: null,
};
const ReducerName = 'scheduleReducer';
const Thunks = {};
const ReducersList = [];
const thunkHelper = thunkHelperFactory(ReducerName, Thunks, ReducersList);
const scheduleSlicer = createSlice({
    name: ReducerName,
    initialState: initState,
    reducers: {
        syncSchedule: (state, action) => {
            state.scheduleSync = action.payload || { type: 'all' };
        },
        changeScheduleEvent: (state, action) => {
            state.scheduleEvent = action.payload;
        },
        updateCatlogList: (state, action) => {
            state.catalogList = action.payload;
        },
        setScheduledDateList: (state, action) => {
            state.scheduledDate = action.payload;
        },
        toggleSelectedCatalogIds: (state, action) => {
            const set = new Set(state.unSelectedCatalogIds);
            if (set.has(action.payload)) {
                set.delete(action.payload);
            }
            else {
                set.add(action.payload);
            }
            saveCatalogUnChecked(Array.from(set));
            state.unSelectedCatalogIds = Array.from(set);
        },
        updateUnSelectedCatalogIds: (state, action) => {
            state.unSelectedCatalogIds = Array.from(action.payload);
        },
        setScheduleEventList: (state, action) => {
            state.scheduleEventList = action.payload;
        },
        setMiniSelectedDay: (state, action) => {
            state.miniSelectedDay = action.payload;
        },
        setCreatDirectStartTime: (state, action) => {
            state.creatDirectStartTime = action.payload;
        },
        setCreatDirectEndTime: (state, action) => {
            state.creatDirectEndTime = action.payload;
        },
        setWeekFirstDay: (state, action) => {
            state.weekFirstDay = action.payload;
        },
        setWeekNumbersVisible: (state, action) => {
            state.weekNumbersVisible = action.payload;
        },
        setActiveStartDate: (state, action) => {
            state.activeStartDate = action.payload;
        },
        setActiveEndDate: (state, action) => {
            state.activeEndDate = action.payload;
        },
        setScheduleEditFrom: (state, action) => {
            state.scheduleEditFrom = action.payload;
        },
        setSettingZoneList: (state, action) => {
            state.settingZoneList = action.payload;
        },
        setShowSecondaryZone: (state, action) => {
            state.showSecondaryZone = action.payload;
        },
        setLastSelectTimezone: (state, action) => {
            state.lastSelectTimezone = action.payload;
        },
    },
});
thunkHelper({
    name: 'updateSchduleList',
    request: (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const rootState = thunkAPI.getState().scheduleReducer;
        const unselectedCatalogIds = rootState.unSelectedCatalogIds.map(item => String(item));
        const { data, requestParams: { start, end }, isAsyncData = false, } = params;
        console.log('updateSchduleList params', start, end, isAsyncData);
        const selectedCatalogData = data.filter((item) => {
            var _a;
            return !unselectedCatalogIds.includes(String((_a = item === null || item === void 0 ? void 0 : item.catalogInfo) === null || _a === void 0 ? void 0 : _a.catalogId));
        });
        dispatch(scheduleSlicer.actions.setScheduleEventList(selectedCatalogData));
        dispatch(Thunks.updateScheduledDateList({ data: selectedCatalogData }));
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.warn('updateSchduleList err0r', error);
    },
});
thunkHelper({
    name: 'updateScheduledDateList',
    request: (params, thunkAPI) => {
        const { dispatch } = thunkAPI;
        const rootState = thunkAPI.getState().scheduleReducer;
        const { scheduleEventList, unSelectedCatalogIds } = rootState;
        const unselectedCatalogIds = unSelectedCatalogIds.map(item => String(item));
        const scheduledDateList = [];
        scheduleEventList.forEach(e => {
            var _a;
            if (unselectedCatalogIds.indexOf(String((_a = e.catalogInfo) === null || _a === void 0 ? void 0 : _a.catalogId)) === -1) {
                scheduledDateList.push(moment(e.scheduleInfo.start).format(SCHEDULED_POINT_FORMAT));
            }
        });
        dispatch(scheduleSlicer.actions.setScheduledDateList(scheduledDateList));
    },
    rejected: (state, action) => {
        var _a;
        const error = ((_a = action === null || action === void 0 ? void 0 : action.error) === null || _a === void 0 ? void 0 : _a.message) || action.payload || action.error;
        console.warn('updateSchduleList err0r', error);
    },
});
export const { actions } = scheduleSlicer;
export const ScheduleThunks = Thunks;
export default scheduleSlicer.reducer;
